__turbopack_context__.v({
  "container": "HeroImage-module__hEfamq__container",
  "heading": "HeroImage-module__hEfamq__heading",
  "headingContainer": "HeroImage-module__hEfamq__headingContainer",
  "image": "HeroImage-module__hEfamq__image",
  "imageContainer": "HeroImage-module__hEfamq__imageContainer",
});
